// console.log('parameter-select.jsが読み込まれました');

//パラメータを取得
const params = new URLSearchParams(location.search);
const url = location.href;

// if(params){
  //パラメーターの数だけ処理を回す
  setTimeout(function(){

    //＜暫定案＞
    if(url.indexOf('?gold=') !== -1 || url.indexOf('?birthstone-1=') !== -1 || url.indexOf('?material=') !== -1 || url.indexOf('?finish=') !== -1 || url.indexOf('?diamond=') !== -1){
      $('.choices').removeClass('hidden');
      for(let param of params){
        var param_name = param[0];
        var param_value = param[1];
        if(param_name === 'gold'){
          param_name = '金種';
        } else if(param_name === 'birthstone-1') {
          param_name = '石';
          if($('select[name="properties[1番目の石]"]').length) {
            param_name = '1番目の石';
          }
        } else if(param_name === 'birthstone-2') {
          param_name = '2番目の石';
        } else if(param_name === 'birthstone-3') {
          param_name = '3番目の石';
        } else if(param_name === 'birthstone-4') {
          param_name = '4番目の石';
        } else if(param_name === 'birthstone-5') {
          param_name = '5番目の石';
        } else if(param_name === 'material') {
          param_name = '素材';
        } else if(param_name === 'finish') {
          param_name = '仕上げ';
        } else if(param_name === 'diamond') {
          param_name = 'ダイヤ留め';
        }
        param_value = $('select[name="properties[' + param_name + ']"] option[data-option_value_key="'+ param_value + '"]').val();
        if(param_value){
          $('.choice_list').append(param_name+'：'+param_value+'<br>');
        }
      }
    }

    // var optionElement = document.querySelector('select[name="properties[金種]"] option[data-option_value_key="1"]');
    // optionElement.selected = true;

    // for(let param of params){
    //   var param_name = param[0];
    //   var param_value = param[1]-1;
    //   //条件分岐
    //   let tgt = '';
    //   if(param_name === 'gold'){
    //     tgt = $('.bold_option_title:contains("金種")').siblings('.bold_option_element').find('select');
    //   } else if(param_name === 'birthstone-1'){
    //     tgt = $('.bold_option_title:contains("1番目の石")').siblings('.bold_option_element').find('select');
    //   } else if(param_name === 'birthstone-2'){
    //     tgt = $('.bold_option_title:contains("2番目の石")').siblings('.bold_option_element').find('select');
    //   } else if(param_name === 'birthstone-3'){
    //     tgt = $('.bold_option_title:contains("3番目の石")').siblings('.bold_option_element').find('select');
    //   } else if(param_name === 'birthstone-4'){
    //     tgt = $('.bold_option_title:contains("4番目の石")').siblings('.bold_option_element').find('select');
    //   } else if(param_name === 'birthstone-5'){
    //     tgt = $('.bold_option_title:contains("5番目の石")').siblings('.bold_option_element').find('select');
    //   }
    //   //実行
    //   let tgtOption = tgt.find('option').eq(param_value);
    //   tgtOption.selected = true;

      // console.log(tgtOption);

      // tgt.options[param_value].selected = true;
      


  //     const param_name = param[0];
  // const param_value = param[1] - 1;

  //パラメーターの値によってセレクト値を変更
  // for(let param of params){
  //   var param_name = param[0];
  //   var param_value = param[1];
  //   let tgt = '';
  //   if (param_name === 'gold') {
  //     tgt = document.querySelector('select[name="properties[金種]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'birthstone-1') {
  //     tgt = document.querySelector('select[name="properties[1番目の石]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'birthstone-2') {
  //     tgt = document.querySelector('select[name="properties[2番目の石]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'birthstone-3') {
  //     tgt = document.querySelector('select[name="properties[3番目の石]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'birthstone-4') {
  //     tgt = document.querySelector('select[name="properties[4番目の石]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'birthstone-5') {
  //     tgt = document.querySelector('select[name="properties[5番目の石]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'material') {
  //     tgt = document.querySelector('select[name="properties[素材]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'finish') {
  //     tgt = document.querySelector('select[name="properties[仕上げ]"] option[data-option_value_key="'+param_value+'"]');
  //   } else if (param_name === 'diamond') {
  //     tgt = document.querySelector('select[name="properties[ダイヤ留め]"] option[data-option_value_key="'+param_value+'"]');
  //   }
  //   if(tgt){
  //     tgt.selected = true;
  //   }
  // }

  // if (tgt) {
  //   tgt.selectedIndex = param_value;
  //   tgt.dispatchEvent(new Event('change'));
  // }


    // }
  }, 1000);
  // $('.bold_option').each(function(){
  //   let param_name = $(this).find('.bold_option_title').text().replace('*', '');
  //   if(param_name === '金種'){
  //     let select = $(this).find('select');
  //     select.prop("selectedIndex", param_value);
  //   }
  // });
// }

// setTimeout(() => {
//   for(let param of params){
//     var param_name = param[0];
//     var param_value = param[1];
//     console.log(param_name,param_value);
//     // $('.' + param_name).find('select').val(param_value);
//     // $('.' + param_name + ' select').val(1);
//     // $('.birthstone-1 select').val(1);
//     // $('.birthstone-1 select').prop("selectedIndex", 2);
//     $('.' + param_name + ' select').prop("selectedIndex", param_value);
//   }
// }, "4000");

// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
// "Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

// Define beforeReady callback
// window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
//   subscribe('appLoad', function(event) {
//     // console.log('appLoad', event);
//   });

//   subscribe('fieldLoad', function(event) {
    // console.log('fieldLoad', event);
    // for(let param of params){
      // var param_name = param[0];
      // var param_value = param[1];
      // console.log(param);

      // $('.' + param_name + ' select').click();
      // $('.' + param_name + ' select').prop("selectedIndex", param_value);

    // }
  // });

  // subscribe('fieldChange', function(event) {
    // console.log('fieldChange', event);
  // });


  // @param {object} event
  // @param {string} event.detail.name The field name of the input.
  // @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
  // @param {object} event.detail.productBundle Details about the bundled product.
  // subscribe('productBundleAdd', function(event) {
    // console.log('productBundleAdd', event);

    // Note: The product variant price returned is cached. You may want to retrieve the latest price.
    // window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(event.detail.productBundle, function(productBundle) {
    //   console.log('Latest productBundle price', event);
    // });
  // });
// };

